import {
    useState,
    useEffect
} from 'react'

import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

import axios from '@shared/utils/axios'
import { useDialogs } from '@shared/hooks/dialogs'

export default function Search({ onClose }) {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState('')
    const { show } = useDialogs()

    useEffect(() => {
        const timer = setTimeout(async () => {
            setLoading(true)

            const res = await axios.get(`/estimations/search/?q=${encodeURIComponent(value)}`)

            setOptions(res.data)
            setLoading(false)
        }, 300)

        return () => clearTimeout(timer)
    }, [value])

    return (
        <Autocomplete
            freeSolo
            options={options}
            inputValue={value}
            onInputChange={(e, newValue) => setValue(newValue)}
            sx={{ flexGrow: 1 }}
            loading={loading}
            getOptionLabel={(option) =>
                typeof option === "string"
                    ? option
                    : `${option.number} - ${option.contractor}`
            }
            onChange={(e, option) => {
                if (!option) return
                if(option.is_draft) {
                    show('estimation', option)
                } else {
                    show('previewEstimation', option)
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onBlur={() => {
                        if (value.trim() == '') {
                            onClose()
                        }
                    }}
                    autoFocus
                    size='small'
                    placeholder="ابحث..."
                />
            )}
        />
    )
}